import { Outlet, NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';

type Tab = { to: string; label: string; isNew?: boolean };
type Group = { title: string; tabs: Tab[] };

// จัดกลุ่มตามงาน — หาเมนูง่าย + ไม่ยัดแถวเดียวจนเละ
const GROUPS: Group[] = [
  {
    title: '🛍️ สินค้า & ราคา',
    tabs: [
      { to: '/settings/brands', label: '🏢 แบรนด์/ธุรกิจ' },
      { to: '/settings/colors', label: '🎨 สี' },
      { to: '/settings/sizes', label: '📏 ไซซ์' },
      { to: '/settings/images', label: '🖼️ รูปสินค้า' },
      { to: '/settings/pricing', label: '💰 ราคา' },
      { to: '/settings/promos', label: '🎁 โปรโมชั่น' },
    ],
  },
  {
    title: '💬 คำตอบบอท',
    tabs: [
      { to: '/settings/answers', label: '💬 คำตอบบอท' },
      { to: '/settings/faq-import', label: '📥 นำเข้า Q&A', isNew: true },
      { to: '/settings/compose', label: '🔗 ตอบรวม', isNew: true },
      { to: '/settings/triggers', label: '⚡ Triggers' },
      { to: '/settings/kb', label: '🧠 KB (แชทจริง)' },
      { to: '/settings/intents', label: '🔧 ตั้งค่าวิเคราะห์/กรอง' },
      { to: '/settings/brand', label: '⚙️ Brand Settings' },
    ],
  },
  {
    title: '🧾 ขาย & ทดสอบ',
    tabs: [
      { to: '/settings/order-builder', label: '🧾 รับออเดอร์' },
      { to: '/settings/preview', label: '🤖 ทดสอบบอต' },
      { to: '/settings/slip', label: '🧾 ทดสอบสลิป' },
    ],
  },
  {
    title: '📊 ระบบ & รายงาน',
    tabs: [
      { to: '/settings/pages', label: '📄 Pages' },
      { to: '/settings/admins', label: '👤 Admins' },
      { to: '/settings/analytics', label: '📊 Analytics' },
      { to: '/settings/ads', label: '📈 วิเคราะห์แอด' },
      { to: '/settings/audit', label: '📋 Audit Log' },
    ],
  },
];

export default function SettingsLayout() {
  return (
    <div className="space-y-4">
      <h1 className="text-xl font-bold">⚙️ ตั้งค่า (Settings)</h1>

      {/* เมนูจัดกลุ่ม — pill ไม่ตัดคำ wrap สวย */}
      <div className="space-y-2.5 border-b border-border pb-3">
        {GROUPS.map((g) => (
          <div key={g.title} className="flex flex-wrap items-center gap-1.5">
            <span className="text-[11px] font-semibold text-muted-foreground w-full sm:w-32 shrink-0">{g.title}</span>
            {g.tabs.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                className={({ isActive }) =>
                  cn(
                    'relative whitespace-nowrap rounded-full px-3 py-1.5 text-sm border transition',
                    isActive
                      ? 'bg-primary text-primary-foreground border-primary'
                      : 'bg-card border-border text-foreground hover:bg-accent',
                  )
                }
              >
                {t.label}
                {t.isNew && (
                  <span className="ml-1 align-middle rounded-full bg-rose-500 px-1.5 py-px text-[9px] font-bold text-white">
                    ใหม่
                  </span>
                )}
              </NavLink>
            ))}
          </div>
        ))}
      </div>

      <div className="pt-1">
        <Outlet />
      </div>
    </div>
  );
}
